import API from '../utils/api';
import { GET_FOOD_ITEMS } from '../constants';
export const tagadd = (tag, cbFn) => {
     return API.post(`/tag/services/register`, tag).then((response) => {
          if (response.data && response.data.status && response.data.status === "success") {
               cbFn(response.data.desc);
          } else if (response.data && response.data.status === "error") {
               cbFn(response.data.desc, true);
          }
     }).catch((error) => {
          cbFn('Unexpected Error', true)
     })
}

//////////new implemented/////
export const tagGet = (tag, cbFn) => {
     return API.get(`/tag/services/get/all`, tag).then((response) => {
          if (response.data && response.data.status && response.data.status === "success") {
               cbFn(response.data.desc);
          } else if (response.data && response.data.status === "error") {
               cbFn(response.data.desc, true);
          }
     }).catch((error) => {
          cbFn('Unexpected Error', true)
     })
}
///////////////////////////////

export const updatetag = (tag, cbFn) => {
     return API.post(`/tag/services/update`, tag).then((response) => {
          if (response.data && response.data.status && response.data.status === "success") {
               cbFn(response.data.desc);
          } else if (response.data && response.data.status === "error") {
               cbFn(response.data.desc, true);
          }
     }).catch((error) => {
          cbFn('Unexpected Error', true)
     })
}

export const deletetag = (tagId, cbFn) => {
     return API.post(`/tag/services/delete/${tagId}`).then((response) => {
          if (response.data && response.data.status && response.data.status === "success") {
               cbFn(response.data.desc);
          } else if (response.data && response.data.status === "error") {
               console.log("response.data.desc--->", response.data)
               cbFn(response.data.desc, true);
          }
     }).catch((error) => {
          cbFn('Unexpected Error', true)
     })
}
